<template>
    <v-main class="mt-n16">
        <span v-for="reminder in reminderList" :key="reminder.id" dense class="mt-n7 mr-n7" style="float:left">
            <ReminderChip :order-id="reminder.orderId" :text="reminder.reminder"></ReminderChip>
        </span>
    </v-main>
</template>

<script>
import ReminderChip from '@/components/admin/chip/ReminderChip'

export default {
    name: 'Dashboard',
    components: {
        ReminderChip,
    },
    data() {
        return {
            reminderList: [
            ]
        }
    },
    methods: {
        async getReminders() {
            await this.$store.dispatch('getReminders')
            this.reminderList = await this.$store.getters.getReminders
        }
    },
    created: async function() {
        await this.getReminders()
        setInterval(await this.getReminders, this.$store.getters.getCommonRefreshInterval)
    }
}
</script>